// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3P-Yu","question":"Question_question__N4-Cq","description":"Question_description__3EiGG"};